import { VStack, Button, FormRow } from '@cad-arc';
import { useCallback } from 'react';
import { useFieldArray } from 'react-hook-form';
import { SubjectStopForm, SubjectStopOptions } from '@mark43/cad-api';
import { FormDateInput } from '../forms/integrated-form-controls/form-date-input';
import { FormNumberInput } from '../forms/integrated-form-controls/form-number-input';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { EMPTY_SUBJECT } from './constants';
import { FrEventSubjectsSection } from './fr-event-subjects-section';

export function FrEventSubjectDataForm({
    subjectStopOptions,
}: {
    subjectStopOptions: SubjectStopOptions;
}) {
    const { form, isSubmitting } = useIntegratedForm<SubjectStopForm>();
    const { fields: subjects, append, remove } = useFieldArray({
        control: form.control,
        name: 'subjectDataForms',
    });

    const addEmptySubject = useCallback(() => {
        append(EMPTY_SUBJECT);
    }, [append]);

    return (
        <VStack width="100%" alignItems="flex-start" gap={1}>
            <FormRow>
                <FormSelect
                    control={form.control}
                    label="Officer"
                    name="userOption"
                    options={subjectStopOptions.userOptions}
                    showRequiredIndicator
                    isDisabled={isSubmitting}
                />
            </FormRow>
            <FormRow>
                <FormDateInput
                    control={form.control}
                    name="stopDateUtc"
                    label="Date and Time"
                    granularity="minute"
                    hasCalendar
                    showRequiredIndicator
                    isDisabled={isSubmitting}
                />
            </FormRow>
            <FormRow>
                <FormNumberInput
                    control={form.control}
                    name="duration"
                    label="Duration"
                    showRequiredIndicator
                    isDisabled={isSubmitting}
                />
            </FormRow>
            {subjects?.map((subject, index) => (
                <FrEventSubjectsSection
                    key={subject.id}
                    index={index}
                    subject={subject}
                    subjectStopOptions={subjectStopOptions}
                    removeSubject={() => remove(index)}
                />
            ))}
            <Button isDisabled={isSubmitting} leadingVisual="Add" onClick={addEmptySubject}>
                Subject
            </Button>
        </VStack>
    );
}
